<template>
  <v-card flat color="grey-lighten-4">
    <v-card-title>
      {{ $t("components.SkillsExplorerConfigForm.title") }}
    </v-card-title>
    <v-divider class="my-2"/>
    <v-card-text>
      <configuration-section-row :show-divider="false">
        <template #name>
          {{ $t('components.SkillsExplorerConfigForm.show_paid_courses') }}
        </template>
        <template #comment>
          Show or hide paid courses in the navigator
        </template>
        <labeled-switch
          v-model="showPaidCourses"
        />
      </configuration-section-row>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn color="primary" @click="save">
        {{ $t('buttons.apply') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {useGlobalStore} from "@/store";
import {ref} from "vue";
import {isYapiError, YapiError} from "@YenzaCT/sdk";
import ConfigurationSectionRow from "@/pages/Settings/AppConfigurationPage/components/ConfigurationSectionRow.vue";
import LabeledSwitch from "@/components/LabeledSwitch.vue";

const store = useGlobalStore();
const {t} = useI18n();

const showPaidCourses = ref(store.appConfiguration.featureSettings.skillsNavigator.showPaidCourses);

async function save(): Promise<void> {
  try {
    const settings = {...store.appConfiguration.featureSettings};
    settings.skillsNavigator.showPaidCourses = showPaidCourses.value;

    await store.saveAppConfiguration("featureSettings", settings);
    store.showSnackbar(t("components.SkillsExplorerConfigForm.save_message"));
  } catch (e) {
    if (isYapiError(e)) {
      const yError = e as YapiError;
      await store.handleYapiError(yError);
    } else {
      throw e;
    }
  }
}
</script>

<style scoped>

</style>
